import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import './FrontPage.css';
import FullbleedHero from '../components/ContentBlocks/FullbleedHero';
import FullbleedContentBlock from '../components/ContentBlocks/FullbleedContentBlock';
import { fetchFront } from '../redux/actions';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import NewsLetter from '../components/NewsLetter/NewsLetter.js';
import Helmet from 'react-helmet';
import Facebook from '../components/Facebook';
import ContentBlockImage from '../components/ContentBlocks/ContentBlockImage'
import ContentBlockHolder from '../components/ContentBlocks/ContentBlockHolder'
import ContentBlock from '../components/ContentBlocks/ContentBlock'
import awardImg from '../assets/img/award.jpg';



class FrontPage extends Component {

  componentDidMount() {
    if (!this.props.headField||!this.props.liftField) {
      this.props.fetchFront(this.props.intl.locale, this.props.date);
    }
  }

  render() {	
    return (
      <div className="front">
        <div>
          <Helmet title="Gaijin" titleTemplate="%s" />
          {!this.props.headField && <Loader/>}
          {this.props.headField && <FullbleedHero fields={this.props.headField}/>}
		  {this.props.containers &&
            this.props.containers.map((key, i) => {
              if(key.sys.contentType.sys.id==='container') {
                if(key.fields.type===true) {
                  const align = key.fields.align.toLowerCase()

                  if((align==='left'||align==='right') && key.fields.image) {
                    return (
                      <ContentBlockImage align={align} fields={key.fields} key={key.sys.id} />
                    )
                  }

                  if(align==='dual') {
                    return (
                      <ContentBlockHolder dual key={key.sys.id}>
                        {key.fields.elements.map((key, i) => {
                          return (
                            <ContentBlock key={key.sys.id} align={key.fields.align.toLowerCase()} fields={key.fields} />
                          )
                        })}
                      </ContentBlockHolder>
                    )
                  }

                  return (
                    <ContentBlockHolder key={key.sys.id}>
                      <ContentBlock align={align} fields={key.fields} />
                    </ContentBlockHolder>
                  )
                }
                if(key.fields.type===false) {
                  return (
                    <FullbleedContentBlock key={key.sys.id} align={key.fields.align.toLowerCase()} fields={key.fields} />
                  )
                }
              }
              return null;
            })
          }
          <div className="newsletter-instagram">
            <div className="container">
              <NewsLetter title classname="newsletter"/>
              <div className="facebook">
              	<Facebook />
              </div>
            </div>
            <div className="container">
                <div className="award"><img src={awardImg} alt="" /></div>
            </div>
          </div>          
        </div>
      </div>
    );
  }
}

FrontPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  headField:state.front.header,
  date:state.date,
  containers:state.front.containers,
  instagrams:state.instagrams,
  lifts:state.front.lifts?
    state.front.lifts.map(x=>{
      return {
        "align":"Center",
        "heading":x.fields.title,
        "content":x.fields.description,
        "leadLinkText":x.fields.linkText,
        "leadLinkUrl":x.fields.link
      }
    })
    :[]
});

const mapDispatchToProps = {
  fetchFront
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(FrontPage));



// WEBPACK FOOTER //
// ./src/containers/FrontPage.js